/**
 * Utility for detecting GrabCAD Print embedding from UserAgent
 */

const userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
const grabCADPrintMatch = userAgent.match(/GrabCADPrint\/([^\s]+)/);

export const isEmbeddedInGrabCADPrint = !!grabCADPrintMatch;
export const grabCADPrintVersion = grabCADPrintMatch ? grabCADPrintMatch[1] : null;
